import { translate } from '../helperFunctions'
import { map } from '../map/tools'
import { codemap } from '../storage'

const andre = v => {
  const str = v === '["", ""]' ? 'D1' : v;
  return str.split(',').slice(1).join(',');
};

function getAllMinimaps() {
  let all = [];
  const htmlCollection = document.getElementsByClassName('minimap');
  const l = htmlCollection.length;
  for (let i = 0; i < l; i++) {
    all.push(htmlCollection[i].data);
  }
  return all;
}

export const getMapsToBeSteered = (btnId) => {
  if (btnId === '' || !btnId) return [map];
  if (btnId === 'K_all') return [map].concat(getAllMinimaps());
  const i = btnId.slice(1);
  const b = document.getElementById('minimap' + i + '_b').data;
  const a = document.getElementById('minimap' + i + '_a').data;
  return [b, a];
};

export function getReadableValue(v, property) {
  if (v === '' || v === '--') return v;
  let text = '';
  if (property.includes('anleggstype'))
    text = translate(codemap['anleggstype'][v]);
  else if (property.includes('datafangstmetode'))
    text = translate(codemap['datafangstmetode'][v]);
  else if (property.includes('reinbeitebruker'))
    text = `${v} (${codemap['reinbeitebruker'][v]})`;
  else if (property.includes('alle_reinbeitebr'))
    text = andre(v);
  else if (property.includes('reinbeiteområde'))
    text = translate(codemap['reinbeiteomrade'][v]);
  else if (property.includes('dom_instans'))
    text = translate(codemap['dominstans'][v]);
  else if (property.includes('sesongomrade'))
    text = translate(codemap['sesongomrade'][v]);
  else if (property.includes('samebyid'))
    text = translate(codemap['samebyid'][v]);
  else if (property.indexOf('status') === 0)
    text = i18n[property][v];
  else if (
    property.includes('maalemetode') || property.includes('noyaktighet') ||
    property.includes('opphav') || property.includes('saksbehandler')
  ) text = v;
  else if (property.includes('dato')) {
    // convert date from ISO format To Norwegian format;
    text = new Date(v).toLocaleDateString();
  } else text = translate(v);
  return text;
}
